<img id="image-avatar"
     [src]="value || DEFAULT_PHOTO"
     (error)="onImageLoadFailed()">
